import { Accordion, ControlledDropDown, FormInput } from '@ui-kit'
import { ShipmentDetailsOrderCaseType } from '../../types/types'
import { FieldValues, useForm } from 'react-hook-form'
import {
  getGenericEntityListingAPI,
  GetGenericEntityListingApiType,
  hideLoader,
  procedureForCreateOrder,
  showLoader,
  useDispatch,
} from '@app-store'
import { useAppSelector } from '../../utils/agent.store'
import { useEffect, useState } from 'react'
import { STRINGS } from '../../utils/strings'
import { ENTITY_FIELDS } from '../../utils/constants'

const ShipmentDetailsOrderCaseCustom = ({
  task,
  mode,
  recordId,
}: ShipmentDetailsOrderCaseType) => {
  const { register, setValue, control } = useForm()
  const [shipToEntityDropDownValues, setShipToEntityDropDownValues] = useState(
    []
  )
  const dispatch = useDispatch()
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const procedureForApiCall = async (e?: FieldValues) => {
    try {
      dispatch(showLoader())
      if (e) {
        await procedureForCreateOrder(recordId?.toString() ?? '', e?.value)
      }

      const payload2 = {
        entity_name: workflowDefinition?.global_variables?.entity_name,
        criteria: [],
        select: ['id', ENTITY_FIELDS.case.c_case_shipment_address_case],
        related_entities: {
          c_case_shipment_address_case: {
            criteria: [],
            select: [
              'id',
              ENTITY_FIELDS.c_case_shipment_address_case.address_line_1,
              ENTITY_FIELDS.c_case_shipment_address_case.address_line_2,
              ENTITY_FIELDS.c_case_shipment_address_case.ship_to_entity,
              ENTITY_FIELDS.c_case_shipment_address_case.city,
              ENTITY_FIELDS.c_case_shipment_address_case.state,
              ENTITY_FIELDS.c_case_shipment_address_case.zipcode,
            ],
          },
        },
      } as GetGenericEntityListingApiType
      const caseIdObject2 = await getGenericEntityListingAPI(payload2, recordId)

      const formData = {
        ship_to_entity:
          caseIdObject2?.c_case_shipment_address_case?.[0]?.ship_to_entity ??
          '',
        address_line_1:
          caseIdObject2?.c_case_shipment_address_case?.[0]?.address_line_1 ??
          '',
        address_line_2:
          caseIdObject2?.c_case_shipment_address_case?.[0]?.address_line_2 ??
          '',
        city: caseIdObject2?.c_case_shipment_address_case?.[0]?.city ?? '',
        state: caseIdObject2?.c_case_shipment_address_case?.[0]?.state ?? '',
        zipcode:
          caseIdObject2?.c_case_shipment_address_case?.[0]?.zipcode ?? '',
      }
      Object.entries(formData).forEach(([key, value]) => setValue(key, value))
    } catch (err) {
      console.error('Error', err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchListForShipToEntity = async () => {
    try {
      const payload = {
        entity_name: 'd_entity_fields',
        select: ['id', 'field_name', 'd_entity_id', 'control_values'],
        criteria: [],
        filters: [
          {
            criteria: [
              {
                values: ['2896'],
                operation: 'EQUALS',
                field_name: 'd_entity_id',
              },
              {
                values: ['ship_to_entity'],
                operation: 'EQUALS',
                field_name: 'field_name',
              },
            ],
          },
        ],
      }
      const caseIdObject1 = await getGenericEntityListingAPI(payload)
      const transformed = caseIdObject1?.[0]?.control_values?.map(
        (item: FieldValues) => ({
          value: item,
          label: item,
        })
      )
      setShipToEntityDropDownValues(transformed)
    } catch (error) {
      console.log(error)
      dispatch(hideLoader())
    } finally {
      dispatch(hideLoader())
    }
  }
  useEffect(() => {
    if (task) {
      fetchListForShipToEntity()
      procedureForApiCall()
    }
  }, [])
  return (
    <Accordion alwaysOpen heading={<span>{STRINGS.SHIPMENT_DETAILS}</span>}>
      <form className="mt-4 grid grid-cols-5 gap-4 pb-4 px-4">
        <ControlledDropDown
          onChange={(e) => procedureForApiCall(e)}
          label={STRINGS.SHIP_TO_ENTITY}
          options={shipToEntityDropDownValues}
          name={ENTITY_FIELDS.c_case_shipment_address_case.ship_to_entity}
          control={control}
          disabled={mode === 'view'}
        />
        <FormInput
          name={ENTITY_FIELDS.c_case_shipment_address_case.address_line_1}
          label={STRINGS.ADDRESS_LINE_1}
          register={register}
          disabled={true}
        />
        <FormInput
          name={ENTITY_FIELDS.c_case_shipment_address_case.address_line_2}
          label={STRINGS.ADDRESS_LINE_2}
          register={register}
          disabled={true}
        />
        <FormInput
          name={ENTITY_FIELDS.c_case_shipment_address_case.city}
          label={STRINGS.CITY}
          register={register}
          disabled={true}
        />
        <FormInput
          name={ENTITY_FIELDS.c_case_shipment_address_case.state}
          label={STRINGS.STATE}
          register={register}
          disabled={true}
        />
        <FormInput
          name={ENTITY_FIELDS.c_case_shipment_address_case.zipcode}
          label={STRINGS.ZIPCODE}
          register={register}
          disabled={true}
        />
      </form>
    </Accordion>
  )
}

export default ShipmentDetailsOrderCaseCustom
